import React from "react";
import { Trans } from "react-i18next";

import "./PoweredBy.less";
const PoweredBy: React.FC = () => {
  return (
    <div className="powered-by">
      <Trans i18nKey="common.poweredBy" components={{ p: <p /> }} />
    </div>
  );
};

export default PoweredBy;
